(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.buildSelectRegion();
      this.hoverBlur();

    }

    buildSelectRegion () {
      this.currency = this.querySelectorAll('[data-region]');
      if(document.querySelectorAll('.region-option').length > 0){
        this.currency.forEach((cur) => {
          cur.innerHTML = this.buildHtmlSelect();
          cur.querySelector('.js-toggle-region').addEventListener('click', (e) => {
            let dom = e.target;
            dom.classList.toggle('active');
            dom.nextElementSibling.classList.toggle('active');
          });
          this.actionClick(cur);
        });
      }
    }

    actionClick (elm) {
      elm.querySelectorAll('li a').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          if(!link.href) return;

          let detailsElement = document.querySelector('#Details-menu-drawer-container');
          let elm = {
            regionPopupContent: document.querySelector('.region-change__popup .region-change__popup-content'),
            regionStay: document.querySelector('.region-change__popup .region-change__stay'),
            regionLeave: document.querySelector('.region-change__popup .region-change__leave'),
            inputDataRegion: document.querySelector(`input[type="radio"][name="region-footer"][id="${link.dataset.id}"]`),
            regionPopup: document.querySelector('.region-change__popup'),
            optionsOverlay: document.querySelector('.region-options-container__overlay')
          }
          createContentRegionPopup(elm);
          document.querySelector('header-drawer').closeMenuDrawer(detailsElement);
          document.querySelector('.js-toggle-region').classList.remove('active');
          document.querySelector('.js-toggle-region').nextElementSibling.classList.remove('active');
        })
      })
    }
 
    buildHtmlSelect() {
      let html = '';
      html += `<span class="js-toggle-region">${document.querySelector('.selected-country').innerHTML}</span>`;
      html += '<ul>';
      document.querySelectorAll('.region-option input').forEach((option) => {
        html += `<li><a ${option.dataset.domain == window.location.host ? `class="region-select"` : `data-id="${option.id}" href="https://${option.dataset.domain}"`}>${option.dataset.name}</a></li>`;
      })
      html += '</ul>';
      return html;
    }

    buildHtmlCurrency() {
      let html = '';
      html += `<span class="js-toggle-region">${document.querySelector('.selected-country').innerHTML}</span>`;
      html += '<ul>';
      document.querySelectorAll('.region-option input').forEach((option) => {
        html += `<li><a ${option.dataset.domain == window.location.host ? `class="region-select"` : `data-id="${option.id}" href="https://${option.dataset.domain}"`}>${option.dataset.name}</a></li>`;
      })
      html += '</ul>';
      return html;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    hoverBlur() {
      const navcontentList = document.querySelectorAll(".list-menu--inline li");
      const childmenuList = document.querySelectorAll(".parent-menu");

      navcontentList.forEach((navcontentItem) => {
        navcontentItem.addEventListener("mouseenter", () => {
          let elem = document.querySelector("cart-notification");
          let search = document.querySelector(".header-super-search").hasAttribute("open");
          let accountHeader = document.querySelector('.mega-nav-login-form');

          if (elem.classList.contains('show')) {
              elem.close();
          }
          
          if(search){
              document.querySelector("details-modal").querySelector("summary").click();
          }

          if (accountHeader.classList.contains('show-mega')) {
            accountHeader.classList.remove('show-mega');
            document.querySelector('.image-white').style.display = 'flex';
            document.querySelector('.image-black').style.display = 'none';
          }

          childmenuList.forEach((childmenuItem) => {
            childmenuItem.classList.add("blur-menu");
            childmenuItem.classList.remove("active-menu");
          });
          const childmenu = navcontentItem.querySelector('.parent-menu');
          if (childmenu) {
            childmenu.classList.add("active-menu");
          }
        });
      });

      const navContainer = document.querySelectorAll(".list-menu--inline li");

      navContainer.forEach((navcontentItem) => {
        navcontentItem.addEventListener("mouseleave", () => {
          childmenuList.forEach((childmenuItem) => {
            childmenuItem.classList.remove("blur-menu");
          });
          const childmenu = navcontentItem.querySelector('.parent-menu');
          if (childmenu) {
            childmenu.classList.remove("active-menu");
          }
        });
      });
     
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
